<template>
  <v-container class="pa-0" style="position: absolute;top: 0;bottom: 0;right: 0;left: 0;">
    <div>
      <v-row justify="center">
        <v-btn class="v-btn-pers" large style="border-radius: 10px 10px 0 0; margin-right: 10px" :style="{ color: colorInvoice}" @click="changeToInvoices()">
          {{ items[0] }}
        </v-btn>
        <v-btn class="v-btn-pers" large style="border-radius: 10px 10px 0 0; margin-left: 10px" :style="{ color: colorCollateral}" @click="changeToCollateral()">
          {{ items[1] }}
        </v-btn>
      </v-row>
      <div v-show="invoices" style="overflow-y: auto; height: calc(100vh - 20vh); width: 100%;">
        <v-tabs-items v-model="tab">
          <v-tab-item
            key="Invoice"
          >
            <v-card
              flat
            >
              <InvoicesTable />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div v-show="collateral">
        <v-tabs-items v-model="tab">
          <v-tab-item
            key="Data"
          >
            <v-card
              flat
            >
              <MyInvoices />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <v-btn
        class="mx-2 btn-primary v-floating-button"
        small
        dark
        style="position:absolute;right:0; bottom: 0; margin-left: 15px; z-index: 100;margin-bottom:10px;border-radius: 10px"
        @click="openDialogInvoicesToMarket"
      >
        <v-icon dark>
          add
        </v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import InvoicesTable from "components/InvoicesTable";
import MyInvoices from "components/MyInvoices";
export default {
    name: "Marketplace",
    components: {InvoicesTable, MyInvoices},
    data () {
        return {
            tab: 0,
            items: ['Public Invoices', 'My collaterals'],
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
            colorInvoice: '#00E5FF',
            colorCollateral: null,
            invoices: true,
            collateral: false,
        };
    },
    methods: {
        openDialogInvoicesToMarket () {
            this.$root.$emit('show-invoicesToMarket-modal', {
                title: this.$t('Byppays to Market'),
                message: this.$t('List byppays to market'),
                yes: () => {
                },
                no: () => {

                }

            });
        },
        changeToInvoices () {
            this.invoices = true;
            this.collateral = false;
            this.colorInvoice = '#00E5FF';
            this.colorCollateral = '#000000';

        },
        changeToCollateral () {
            this.invoices = false;
            this.collateral = true;
            this.colorInvoice = '#000000';
            this.colorCollateral = '#00E5FF';
        },
    }

};
</script>

<style scoped>
.v-btn-pers{
  /*padding:  !important;*/
  background-color: white !important;
  text-underline-offset: 10px;
  text-decoration: underline;
  display: flex;
  margin-top: 5%;
  margin-right: 2%;
  margin-left: 2%;
}
.v-floating-button{
  min-width: 30px !important;
  min-height: 50px !important;
}
</style>
